export default {
  suggestStart: `Other categories related to '`,
  suggestEnd: `'`,
  navLinkTitle: text => `Search ${text}`
}
